import * as React from 'react';
import { connect } from 'react-redux';
import { BaseAnalyzePlayers, BaseElement, FilterDates, Table } from '../components';
import { ContainerContext, mapProps } from './index';
import { ActionRequest } from '../actions';
import { formatDate, getPlayerLink, truncateNumber } from '../utils';
import { default as moment, Moment } from 'moment';
import { useNavigate } from 'react-router';
import { StateMap } from '../reducers';
import useMediaQuery from '@mui/material/useMediaQuery';

interface Props extends ContainerContext.Props {
}

interface State {
    readonly startTimeSpam: Moment;
    readonly endTimeSpam: Moment;
}

class Container extends BaseElement<Props, State> {
    state = {
        startTimeSpam: moment.parseZone().subtract(24, 'hours'),
        endTimeSpam: moment.parseZone(),
    };

    protected renderContainer(): React.JSX.Element {
        return (
            <BaseAnalyzePlayers {...this.props} >
                {this.renderContent()}
            </BaseAnalyzePlayers>
        );
    }

    private renderContent = () => {
        const columns = [
            { title: 'Player Id', field: 'playerId'},
            { title: 'Name', field: 'name'},
            { title: 'Value', field: 'value'},
            { title: 'Updated Date', field: 'updated'},
            { title: 'Created Date', field: 'created'},
        ];

        const { startTimeSpam, endTimeSpam} = this.state;
        const tableRef = React.createRef();
        const onSearch = () => {
            // @ts-ignore
            tableRef.current.retry();
        };

        const onFilterDates = (start: Moment, end: Moment) => {
            this.setState({ startTimeSpam: start, endTimeSpam: end});
            onSearch();
        };

        return (
            <Table
                styled={this.props.styled}
                tableRef={tableRef}
                title={<div style={{ display: 'flex', justifyContent: 'flex-end', padding: '10px 20px 0px' }}>
                    <FilterDates
                        styled={this.props.styled}
                        start={startTimeSpam}
                        end={endTimeSpam}
                        onFilter={onFilterDates}
                    />
                </div>}
                columns={columns}
                options={{
                    selection: false,
                    paging: true,
                    pageSize: 10,
                    pageSizeOptions: [5, 10, 30, 50, 100],
                    emptyRowsWhenPaging: false,
                    search: true,
                    sorting: true,
                    draggable: false,
                }}
                data={this.getData}
            />
        );
    };

    private getData = async (query: any) => {
        const { startTimeSpam, endTimeSpam } = this.state;
        const { search, page, pageSize, orderBy, orderDirection } = query;
        const result = await ActionRequest.get(`analyze/players/matchmakings`, {
            filter: search,
            page: page + 1,
            perPage: pageSize,
            orderBy: orderBy ? orderBy.field : null,
            orderDirection: orderDirection !== "" ? orderDirection : null,
            startTimeSpam: startTimeSpam.valueOf(),
            endTimeSpam: endTimeSpam.valueOf(),
        });
        if (!result) {
            return {
                data: [],
                page: 0,
                totalCount: 0,
            };
        }
        const data = result.data.map((d: any) => {
            return {
                playerId: getPlayerLink(d.playerId),
                name: d.name,
                value: truncateNumber(d.value),
                updated: formatDate(d.updated),
                created: formatDate(d.created),
            };
        });

        return {
            data,
            page: result.page - 1,
            totalCount: result.totalCount,
        };
    };
}

const mapStateToProps = (state: StateMap): Props => ({
    ...mapProps(state),
});
const AppContainer = (props: Props) =>
{
    const smallUp = useMediaQuery((theme) => theme.breakpoints.up('sm'));
    const navigate = useNavigate();
    return (<Container {...props} styled={{themeMode: props.app.themeMode, smallUp}} navigate={navigate}/>);
};
export default connect(mapStateToProps)(AppContainer);
